<button type="button" #bttv2ColumnSelectButton command="show-modal" commandfor="bttv2ColumnSelectDialog"
    class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
    Select Columns
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="-mr-0.5 size-5">
        <rect width="7" height="13" x="3" y="8" rx="1" />
        <path d="m15 2-3 3-3-3" />
        <rect width="7" height="13" x="14" y="8" rx="1" />
    </svg>
</button>

<el-dialog>
    <dialog #bttv2ColumnSelectDialog id="bttv2ColumnSelectDialog" aria-labelledby="bttv2ColumnSelectDialog-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">

        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>

        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">
            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
                        <div class="px-2 py-4 drawer-header-primary" style="padding-bottom: 0 !important;">
                            <div class="w-full flex flex-col items-start justify-center space-y-2 ">
                                <div class="flex space-x-3 h-full items-start w-full">
                                    <div class="min-w-0 flex-1 px-2">
                                        <p class="text-md font-semibold text-primary" id="bttv2ColumnSelectDialog-title">
                                            Select Columns
                                        </p>
                                        <p class="text-sm text-secondary">
                                            Select the columns you want to display.
                                        </p>
                                    </div>

                                    <div class="h-full flex flex-col justify-between items-end">

                                        <button type="button" (click)="closeDrawer()"
                                            class="fab-button-secondary text-secondary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M18 6 6 18" />
                                                <path d="m6 6 12 12" />
                                            </svg>
                                        </button>

                                    </div>
                                </div>

                                <div class="w-full flex items-center">
                                    <nav aria-label="Column categories"
                                        class="flex flex-row w-full justify-center gap-x-4 cursor-pointer flex-wrap">

                                        <a (click)="setTab('delivery')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('delivery')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('delivery') + (selectedTab() === 'delivery' ? ' mr-1.5' : '')">
                                                <rect width="18" height="18" x="3" y="3" rx="2" />
                                                <path d="M3 9h18" />
                                                <path d="M9 21V9" />
                                            </svg>
                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'delivery' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Delivery
                                            </span>
                                        </a>

                                        <a (click)="setTab('bidding')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('bidding')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('bidding') + (selectedTab() === 'bidding' ? ' mr-1.5' : '')">
                                                <path d="M12 16v5" />
                                                <path d="M16 14v7" />
                                                <path d="M20 10v11" />
                                                <path
                                                    d="m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15" />
                                                <path d="M4 18v3" />
                                                <path d="M8 14v7" />
                                            </svg>
                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'bidding' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Bidding
                                            </span>
                                        </a>

                                        <a (click)="setTab('targeting')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('targeting')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('targeting') + (selectedTab() === 'targeting' ? ' mr-1.5' : '')">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <circle cx="9" cy="7" r="4" />
                                            </svg>
                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'targeting' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Targeting
                                            </span>
                                        </a>

                                        <a (click)="setTab('advanced')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('advanced')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('advanced') + (selectedTab() === 'advanced' ? ' mr-1.5' : '')">
                                                <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                                                <circle cx="12" cy="12" r="3" />
                                            </svg>
                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'advanced' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Advanced
                                            </span>
                                        </a>

                                    </nav>
                                </div>
                            </div>
                        </div>

                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-y-auto drawer-body-primary divide-y divide-border scrollbar-transparent">

                            @switch (selectedTab()) {
                            @case ('delivery') {
                            @for (col of deliveryCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            @case ('bidding') {
                            @for (col of biddingCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            @case ('targeting') {
                            @for (col of targetingCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            @case ('advanced') {
                            @for (col of advancedCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            }

                        </div>

                        <div class="px-2 py-2 drawer-header-primary">
                            <div class="flex flex-row items-center justify-between">

                                <button type="button" (click)="clear()"
                                    class="secondary-button rounded-full px-2.5 py-1 text-xs font-semibold text-primary">Clear</button>

                                <button type="button" (click)="apply()"
                                    class="inline-flex items-center gap-x-1.5 primary-button">
                                    Apply
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="-mr-0.5 size-5">
                                        <path
                                            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>
